import React from "react";
import { Box, Typography, Alert, Button } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { Add as AddIcon } from "@mui/icons-material";
import { usePaymentHistoryManagement } from "./usePaymentHistoryManagement";
import PaymentHistoryFilters from "./PaymentHistoryFilters";
import PaymentStatistics from "./PaymentStatistics";
import PaymentHistoryList from "./PaymentHistoryList";
import ManualPaymentDialog from "../../Attendance/ManualPaymentDialog/ManualPaymentDialog";
import AttendeeSelectionDialog from "./AttendeeSelectionDialog";
import EditManualPaymentDialog from "./EditManualPaymentDialog";
import DeleteManualPaymentDialog from "./DeleteManualPaymentDialog";

export const PaymentHistoryManagement: React.FC = () => {
  const {
    paymentHistory,
    totalPaymentHistory,
    paymentStatistics,
    loading,
    error,
    attendees,
    page,
    rowsPerPage,
    orderBy,
    order,
    filters,
    selectedAttendee,
    isManualPaymentDialogOpen,
    isAttendeeSelectionDialogOpen,
    selectedPaymentForEdit,
    isEditPaymentDialogOpen,
    selectedPaymentForDelete,
    isDeletePaymentDialogOpen,
    handleChangePage,
    handleChangeRowsPerPage,
    handleRequestSort,
    handleFilterChange,
    handleAddManualPaymentClick,
    handleAttendeeSelectionClose,
    handleAttendeeSelect,
    handleManualPaymentClose,
    handleManualPaymentSuccess,
    handleEditManualPayment,
    handleEditPaymentClose,
    handleEditPaymentSuccess,
    handleDeleteManualPayment,
    handleDeletePaymentClose,
    handleDeletePaymentSuccess,
  } = usePaymentHistoryManagement();

  return (
    <Box>
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h4" component="h1">
          <FormattedMessage
            id="admin.paymentHistory.title"
            defaultMessage="Payment History"
          />
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleAddManualPaymentClick}
        >
          <FormattedMessage
            id="admin.paymentHistory.addManualPayment"
            defaultMessage="Add Manual Payment"
          />
        </Button>
      </Box>

      <PaymentStatistics statistics={paymentStatistics} loading={loading} />

      <PaymentHistoryFilters
        filters={filters}
        onFilterChange={handleFilterChange}
        attendees={attendees}
      />

      <PaymentHistoryList
        payments={paymentHistory}
        total={totalPaymentHistory}
        page={page}
        rowsPerPage={rowsPerPage}
        orderBy={orderBy}
        order={order}
        onRequestSort={handleRequestSort}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
        onEditManualPayment={handleEditManualPayment}
        onDeleteManualPayment={handleDeleteManualPayment}
      />

      <AttendeeSelectionDialog
        open={isAttendeeSelectionDialogOpen}
        onClose={handleAttendeeSelectionClose}
        onSelectAttendee={handleAttendeeSelect}
        attendees={attendees}
        loading={loading}
      />

      {selectedAttendee && (
        <ManualPaymentDialog
          open={isManualPaymentDialogOpen}
          onClose={handleManualPaymentClose}
          attendee={selectedAttendee}
          onManualPaymentCreated={handleManualPaymentSuccess}
        />
      )}

      <EditManualPaymentDialog
        open={isEditPaymentDialogOpen}
        onClose={handleEditPaymentClose}
        payment={selectedPaymentForEdit}
        onSuccess={handleEditPaymentSuccess}
      />

      <DeleteManualPaymentDialog
        open={isDeletePaymentDialogOpen}
        onClose={handleDeletePaymentClose}
        payment={selectedPaymentForDelete}
        onSuccess={handleDeletePaymentSuccess}
      />
    </Box>
  );
};
